import hydrate from '../common/hydrate';
import FooterLinkSection from './components/FooterLinkSection';
import { root, name } from './manifest.json';
hydrate(FooterLinkSection, root, name);
if (module.hot) {
    module.hot.accept();
}
